<template>
    
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <router-link :to="{ name: 'tambah-voucher'}"  class="btn btn-primary" v-if="myGlobal.RootOnly()">Tambah Voucher</router-link>
        </div>
      </div>
      <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="card-title ">Daftar Voucher</h4>
                    <p class="card-category">Berikut daftar Voucher anda</p>
                  </div>
                  <div class="col-md-6" v-show="false">
                    <h2 class="card-title text-right">{{data.filtered}}</h2>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th width="40px">No.</th>
                      <th>Nama</th>
                      <th>Mikrotik</th>
                      <th>Tarif</th>
                      <th>Status</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in theGet.data.List">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.paket_nama }}</br> <span class="text-secondary">Ket : {{ u.paket_keterangan }}</span></td>
                        <td>{{ u.mikrotik_nama }}</td>
                        <td>{{ ribu(u.paket_tarif) }}</td>
                        <td>
                            <span v-if="u.status == 'terpakai'" class="text-success">Terpakai</span>
                            <span v-else class="text-danger">Belum</span>
                        </td>
                      </tr>
                      <tr v-if="theGet.data.List == null">
                        <td></td>
                        <td>Tidak ada Data </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
      </div>

      <!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="false">
        <div class="overlay"></div>
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Tarif Voucher</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="form-group">
                      <label class="bmd-label-floating">Nama Paket</label>
                      <input type="text" class="form-control" placeholder="Nama Paket...">  
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger">Hapus</button>
              <button type="button" class="btn btn-secondary">Cancel</button>
              <button type="button" class="btn btn-success">Simpan</button>
            </div>
          </div>
        </div>
      </div>


    </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

import { url,homePage } from '@/var/var.js'
import VueBarcode from 'vue-barcode';

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

Vue.use(moment)

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
    const data = reactive({
      filtered: '',

      /* modal edit tarif */
    })

    const theGet = {
      data: reactive({
          List: [],
      }),
      datae() {
        //console.log(sessionStorage.getItem('admin'));
        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            subadmin: sessionStorage.getItem('admin'),
            status: "all"
        };
    
        var apiUrl = inter.voucherList();
        myGlobal.call(datax,apiUrl).then(x => {
            //console.log(JSON.stringify(x));
            if (x.status == true) {
                this.data.List = x.data;
            } else {
                //alert(x.pesan);
            }
        })
      }
    }
    return {
      data, 
      theGet,
      myGlobal
    }
  },
  mounted () {
    document.title = "Daftar Tarif Voucher";

    this.theGet.datae();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/voucher/list.vue